import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { RentalObjectCategory } from './const/enums';

export class BlockRentalObject extends ModelBase {
  constructor() {
    super();
  }

  caption: string = '';
  validFromDate: LocalDate = null;
  validToDate: LocalDate = null;
  propertyId: string;
  category: RentalObjectCategory;

  toString(culture?: string): string {
    return this.caption;
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
        return this.toString();

      case 'list':
        return this.toString(culture);
    }
  }
}
